import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { EmployeeTaskDetailReportTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { EmployeeTaskDetailReportschemaObject } from "../EmployeeTaskDetailReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _, { forEach } from 'lodash';
import MaterialTable from "material-table";
import moment from 'moment';

const screenCode = "EMPLOYEETASKDETAILREPORT";

export function EmployeeTaskDetailReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [taskCategory, setTaskCategory] = useState();
    const [labourTask, setLabourTask] = useState()
    const [gtnnumber, setGtnnumber] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [employeCount, setEmployeCount] = useState([]);

    const [employeeTaskDetailReport, setEmployeeTaskDetailReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        fromDate: "",
        toDate: "",
        category: "0",
        task: "0",
        registrationNumber: "",
        employeCount: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        fromDate: "",
        toDate: "",
        category: "0",
        task: "0",
        registrationNumber: ""
    })
    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(EmployeeTaskDetailReportschemaObject).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName", "fieldName", "estateTaskName",
        "taskName", "progress", "createdDate", "startTime", "endTime"]
    const csvHeaders = [
        { label: "Division", value: "collectionPointName" },
        { label: "Field", value: "fieldName" },
        { label: "Category", value: "estateTaskName" },
        { label: "Task", value: "taskName" },
        { label: "Percentage%", value: "progress" },
        { label: "Date", value: "createdDate" },
        { label: "Start Time", value: "startTime" },
        { label: "End Time", value: "endTime" },
    ];

    const [reportData, setReportData] = useState([]);
    const [keys, setKeys] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),

        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
            getTaskNames(),

        )
    }, [employeeTaskDetailReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
            getTaskNames(),

            getLabourTask()
        )
    }, [employeeTaskDetailReport.estateID])

    useEffect(() => {
        trackPromise(
            getGtnNumberForDropDown()
        )
    }, [employeeTaskDetailReport.searchDate])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setEmployeeTaskDetailReport({
            ...employeeTaskDetailReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setEmployeeTaskDetailReport({
            ...employeeTaskDetailReport,
            estateID: target.value,
            divisionID: "0"

        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeTaskDetailReportschemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEETASKDETAILREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setEmployeeTaskDetailReport({
            ...employeeTaskDetailReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    function destroyDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable().destroy();
        })
    }

    function createDataTable() {
        keys.forEach(e => {
            $(`#${e}`).DataTable();
        })
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(employeeTaskDetailReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(employeeTaskDetailReport.estateID);
        setDivisions(data);
    }

    async function getTaskNames() {
        const result = await services.getAllTaskNames(employeeTaskDetailReport.groupID, employeeTaskDetailReport.estateID);
        setTaskCategory(result);
    }

    async function getLabourTask() {
        const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(employeeTaskDetailReport.estateID)
        setLabourTask(result)
    }


    async function getGtnNumberForDropDown() {
        const data = await services.getGtnNumberByCollectionPointIDandDate(employeeTaskDetailReport);
        setGtnnumber(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleTaskNameChange(target) {

        setEmployeeTaskDetailReport({
            ...employeeTaskDetailReport,
            registrationNumber: target.value,
        });
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.type === "checkbox" ? target.checked : target.value;
        setEmployeeTaskDetailReport({
            ...employeeTaskDetailReport,
            [e.target.name]: value,
        });
    }


    async function handleSearch(e) {
        setIsTableHide(true);

        setButtonHide(true);


        getSelectedDropdownValuesForReport(employeeTaskDetailReport);

        const errorMessages = validate(schema, employeeTaskDetailReport);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getEmployeeTaskDetailReportData(employeeTaskDetailReport);

        var employeeCount = result.count;
        var employeeData = result.result;

        setEmployeCount(employeeCount);

        setIsTableHide(true);


        let keys = Object.keys(employeeData);

        setKeys(keys);
        setReportData(employeeData);

        if (employeeData.length > 0) {
            employeeData.forEach(x => {
                x.createdDate = x.createdDate.split('T')[0];
                x.startTime = moment(x.startTime).format('h:mm:ss a');
                x.endTime = moment(x.endTime).format('h:mm:ss a');
            })
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }


        setButtonHide(false);
        setIsReportButtonsEnabled();

        const comlpeteData = [...employeeData];
        setCsvData(comlpeteData)
    }

    function createFile() {
        var settings = {
            sheetName: 'Employee Task Detail Report',
            fileName: 'EmployeeTaskDetailReport',
            writeOptions: {}


        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointName: "Emp Name: " + reportData[0].firstName,
            fieldName: "Emp Type : " + reportData[0].employeeTypeName,
            estateTaskName: "Reg No: " + reportData[0].registrationNumber,
            taskName: "NOD : " + employeCount[0].employeCount,
        }
        var newRow2 = {
            collectionPointName: "Group :" + groups[employeeTaskDetailReport.groupID],
            fieldName: "Operation Entity : " + estates[employeeTaskDetailReport.estateID],
            estateTaskName: "From Date : " + employeeTaskDetailReport.fromDate,
            taskName: "To Date : " + employeeTaskDetailReport.toDate,
            progress: "Registration Number : " + employeeTaskDetailReport.registrationNumber,
            createdDate: "Generated date/time : " + new Date().toLocaleString(),
            startTime: "Generated user : " + tokenService.getUserNameFromToken()

        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            registrationNumber: searchForm.registrationNumber,
            category: taskCategory[searchForm.category],
            task: labourTask[searchForm.task],
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Employee Task Detail Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={employeeTaskDetailReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={employeeTaskDetailReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="category">Category</InputLabel>
                                        <Select
                                            fullWidth
                                            id="category"
                                            name="category"
                                            value={employeeTaskDetailReport.category}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Task Category--</MenuItem>
                                            {generateDropDownMenu(taskCategory)}
                                        </Select>
                                    </div>


                                </div>

                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="sundryTask">Task</InputLabel>
                                        <Select
                                            fullWidth
                                            id="task"
                                            name="task"
                                            value={employeeTaskDetailReport.task}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Task--</MenuItem>
                                            {generateDropDownMenu(labourTask)}
                                        </Select>
                                    </div>

                                    <div className="col-md pb-1">
                                        <TextField
                                            id="fromDate"
                                            label="From Date *"
                                            name="fromDate"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField
                                            id="toDate"
                                            label="To Date *"
                                            name="toDate"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}

                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <InputLabel shrink id="registrationNumber">
                                            Registration Number*
                                        </InputLabel>
                                        <TextField
                                            fullWidth
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={employeeTaskDetailReport.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleTaskNameChange(e.target)}
                                        />
                                        {errors["registrationNumber"] && (
                                            <FormHelperText
                                                id="errbranchCode"
                                                className="text text-danger"
                                            >
                                                {errors["registrationNumber"]}
                                            </FormHelperText>
                                        )}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <div className="table-responsive row-top-gap" >
                                        <div className="card shadow-none bg-light">
                                            <div className="row alternative_cls bg-light  ">
                                                <div className="card-body width1"><p><b><p />Emp Name: </b>{reportData[0].firstName}</p> </div>
                                                <div className="card-body width2"><p><b><p />Emp Type: </b>{reportData[0].employeeTypeName} </p> </div>
                                                <div className="card-body width3"><p><b><p />Reg No: </b>{reportData[0].registrationNumber}</p> </div>
                                                <div className="card-body width3"><p><b><p />NOD: </b>{employeCount[0].employeCount}</p></div>

                                            </div>
                                            <div className="table-responsive row-top-gap">
                                                <MaterialTable
                                                    title="Multiple Actions Preview"
                                                    columns={[
                                                        { title: 'Collection Point', field: 'collectionPointName', headerStyle: { fontWeight: "bold" } },
                                                        {
                                                            title: 'Field', field: 'fieldName', headerStyle: { fontWeight: "bold" }, lookup: {
                                                                null: "-"
                                                            }
                                                        },
                                                        { title: 'Category', field: 'estateTaskName', headerStyle: { fontWeight: "bold" } },
                                                        { title: 'Task', field: 'taskName', headerStyle: { fontWeight: "bold" } },
                                                        { title: 'Percentage (%)', field: 'progress', headerStyle: { fontWeight: "bold" } },
                                                        { title: 'Date', field: 'createdDate', headerStyle: { fontWeight: "bold" } },
                                                        { title: 'Start Time', field: 'startTime', headerStyle: { fontWeight: "bold" } },
                                                        { title: 'End Time', field: 'endTime', headerStyle: { fontWeight: "bold" } }

                                                    ]}
                                                    data={reportData}
                                                    options={{
                                                        exportButton: false,
                                                        showTitle: false,
                                                        headerStyle: { textAlign: "left", height: '1%' },
                                                        cellStyle: { textAlign: "left" },
                                                        columnResizable: false,
                                                        actionsColumnIndex: -1
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Employee Task Detail Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} employeCount={employeCount}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
